<template>
  <div
    class="card mb-5 mb-xl-10"
    id="kt_profile_details_view"
    style="margin-bottom: 0 !important"
  >
    <div class="card-header cursor-pointer">
      <div class="card-title m-0">
        <h3 class="fw-bolder m-0">Profil Bilgilerim</h3>
      </div>
      <router-link
        class="btn btn-primary align-self-center"
        :to="{ name: 'profileSettings' }"
        v-slot="{ href, navigate, isActive }"
      >
        <a :href="href" :class="{ active: isActive }" @click="navigate">
          Bilgilerimi Düzenle
        </a>
      </router-link>
    </div>
    <div class="card-body p-9" v-if="user">
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted">Ad Soyad</label>
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-gray-800"
            >{{ user.name }} {{ user.surname }}</span
          >
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted">Telefon</label>
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{ user.phone }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted">E-posta</label>
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{ user.email }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted">T.C. Kimlik Numarası</label>
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{ user.tc }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Kronik bir hastalığınız var mı?</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6"
            >{{ user.kronik
            }}{{ `${user.kronik_cevap ? ", " + user.kronik_cevap : ""}` }}</span
          >
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Daha önce psikolojik tedavi ya da ilaç tedavisi aldınız mı?</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6"
            >{{ user.ilac
            }}{{ `${user.ilac_cevap ? ", " + user.ilac_cevap : ""}` }}</span
          >
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Kendinize ya da çevrenize zarar verme eğiliminiz var mı?</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{ user.suicide }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Alkol kullanıyor musunuz?</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{ user.alkol }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Gerekli olduğunda yüz yüze görüşmek isterim</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{
            user.requiredMeeting
          }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Acil durumlarda aranacak kişinin isim ve soyismi</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{
            user.emergencyContact
          }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Acil durumlarda aranacak kişinin telefon numarası</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{
            user.emergencyContactNumber
          }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Başvuru nedenizi belirtiniz</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{ user.problem }}</span>
        </div>
      </div>
      <div class="row mb-7">
        <label class="col-lg-4 fw-bold text-muted"
          >Belirtmek istediğiniz özel durumlar</label
        >
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{ user.conditions }}</span>
        </div>
      </div>
      <div class="row mb-7" style="margin-bottom: 0 !important">
        <label class="col-lg-4 fw-bold text-muted">Kayıt Tarihi</label>
        <div class="col-lg-8 fv-row">
          <span class="fw-bold text-gray-800 fs-6">{{
            makeDate(user.created_at)
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
export default {
  data() {
    return {
      token: this.$store.getters.getAccessToken,
      user: null,
    };
  },
  async created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo: async function () {
      let vm = this;

      if (!vm.token) return;

      let response = await API.getUserInfo(vm.token);

      if (response.status == "fail")
        return vm.$store.dispatch("logout").then(() => location.reload());

      vm.user = response.data;
    },
    makeDate: function (date) {
      let d = new Date(date);

      let months = [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık",
      ];

      let day = d.getDate();
      let month = d.getMonth();
      let year = d.getFullYear();

      let _date = `${day < 10 ? "0" + day : day} ${months[month]} ${year}`;

      return _date;
    },
  },
};
</script>